export type SiteRoute = 'home' | 'market' | 'detail' | 'listing' | 'orders' | 'inventory' | 'messages' | 'account' | 'agreement' | 'privacy' | 'saleRules' | 'rewards' | 'coupons' | 'mall' | 'mallVouchers' | 'mallOrders';

const routes: Record<string, SiteRoute> = { '/': 'home', '/market': 'market', '/orders': 'orders', '/inventory': 'inventory', '/messages': 'messages', '/account': 'account', '/agreement': 'agreement', '/privacy': 'privacy', '/sale-rules': 'saleRules', '/rewards': 'rewards', '/coupons': 'coupons', '/mall': 'mall', '/mall/vouchers': 'mallVouchers', '/mall/orders': 'mallOrders' };

export function itemIdFromHash(hash: string, kind: 'item' | 'listing'): string | undefined {
  const path = hash.replace(/^#/, '').split('?')[0] ?? '';
  const prefix = `/${kind}/`;
  if (!path.startsWith(prefix)) return undefined;
  try { return decodeURIComponent(path.slice(prefix.length)).trim() || undefined; }
  catch { return undefined; }
}

export function resolveSiteRoute(hash: string): SiteRoute {
  const path = hash.replace(/^#/, '').split('?')[0] || '/';
  if (path.startsWith('/item/')) return 'detail';
  if (path.startsWith('/listing/')) return 'listing';
  if (path.startsWith('/orders/')) return 'orders';
  if (path.startsWith('/account/')) return 'account';
  return routes[path] ?? 'home';
}
